import React from "react";

import { useField, useFormikContext } from "formik";

export const RadioButtonField = ({
  fieldName,
  value,
  label,
  disabled,
  educacao,
  edit,
  loadingScroll,
  setScrollLoading,
}) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField({ name: fieldName, type: "radio", value: value });

  const handleClickScroll = () => {
    if (fieldName === "compartilharProcesso" && value === "S") {
      setScrollLoading && setScrollLoading(true);
    } else {
      setScrollLoading && setScrollLoading(false);
    }
  };
  const handleClick = () => {
    const currentValue = field.value;
    const isChecked = currentValue === value;

    setFieldValue(fieldName, isChecked ? "N" : value);
  };
  return (
    <label
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        cursor: "pointer",
        whitespace: "nowrap",
      }}>
      <input
        {...field}
        type="radio"
        style={{
          cursor: "pointer",
          width: edit && "20px",
          height: edit && "20px",
        }}
        disabled={disabled}
        onClick={
          educacao
            ? handleClick
            : loadingScroll
            ? () => handleClickScroll()
            : null
        }
      />
      <span
        style={{
          marginLeft: "5px",
          whiteSpace: "nowrap",
        }}>
        {label}
      </span>
    </label>
  );
};
